/**
 * 独立版商品接口列表
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const goodsAlone = {
    //独立版获取所有商品信息
    getAllGoodsInfoAlone(params) {
        return axios.post('/goods/mobileGoodsAlone/getAllGoodsInfoAlone', qs.stringify(params));
    },
    //手机前台根据商品id列表获取商品详细信息（独立版）
    getAllGoodsInfoAloneById(params) {
        return axios.post('/goods/mobileGoodsAlone/getAllGoodsInfoAloneById', qs.stringify(params));
    },
    //手机前台获取商品详情信息（独立版）
    getGoodsDetailAlone(params) {
        return axios.post('/goods/mobileGoodsAlone/getGoodsDetailAlone', qs.stringify(params));
    },
    //手机前台获取客户足迹商品信息（独立版）
    getUserHistoryGoodsInfo(params) {
        return axios.post('/goods/mobileGoodsAlone/getUserHistoryGoodsInfo', qs.stringify(params));
    },
    //获取活动列表信息
    getActivityList(params) {
        return axios.post('/goods/mobileActivityAlone/getActivityList', qs.stringify(params));
    },
    //通过活动id获取活动商品信息
    getActivityGoodsList(params) {
        return axios.post('/goods/mobileActivityAlone/getActivityGoodsList', qs.stringify(params));
    },
    //活动商品加入购物车
    addActivityGoodsBucket(params) {
        return axios.post('/goods/mobileActivityAlone/addActivityGoodsBucket', qs.stringify(params));
    },
    //组合套餐商品加入购物车
    addPackageActivityGoodsBucket(params) {
        return axios.post('/goods/mobileActivityAlone/addPackageActivityGoodsBucket', qs.stringify(params));
    },
    //手机前台获取商品包装所在所有组合套餐活动（独立版）
    getPackageActivityByGoodsPackId(params) {
        return axios.post('/goods/mobileGoodsAlone/getPackageActivityByGoodsPackId', qs.stringify(params));
    },
    //手机前台获取品牌汇列表信息（独立版）
    getBrandRemitListAlone(params) {
        return axios.post('/goods/mobileBrandRemitAlone/getBrandRemitListAlone', qs.stringify(params));
    },
    //获取品牌汇活动商品列表信息（独立版）
    getBrandRemitGoodsListAlone(params) {
        return axios.post('/goods/mobileBrandRemitAlone/getBrandRemitGoodsListAlone', qs.stringify(params));
    },
    //手机前台获取品牌汇详情信息（独立版）
    getMobileBrandRemitDetailAlone(params) {
        return axios.post('/goods/mobileBrandRemitAlone/getMobileBrandRemitDetailAlone', qs.stringify(params));
    },
    //获取商品促销活动列表信息
    getGoodsPromotionInfo(params) {
        return axios.post('/goods/mobileActivityAlone/getGoodsPromotionInfo', qs.stringify(params));
    },
    //获取商品促销活动所有商品信息
    getGoodsPromotionGoodsInfo(params) {
        return axios.post('/goods/mobileActivityAlone/getGoodsPromotionGoodsInfo', qs.stringify(params));
    },
    //手机前台首页获取商品推荐商品信息（独立版）
    getHomeRecommondGoodsAlone(params) {
        return axios.post('/goods/mobileGoodsAlone/getHomeRecommondGoodsAlone', qs.stringify(params));
    },
    //获取手机前台客户足迹页面商品（独立版）
    showUserHistoryGoodsAlone(params) {
        return axios.post('/goods/mobileGoodsAlone/showUserHistoryGoodsAlone', qs.stringify(params));
    },
    //根据商品id获取退货商品列表信息
    getAllRefundGoodsInfoAloneById(params) {
        return axios.post('/order/mobileRefundAlone/getAllRefundGoodsInfoAloneById', qs.stringify(params));
    },
    //修改退货购物车数量
    changeRefundBucketNum(params) {
        return axios.post('/order/mobileRefundAlone/changeRefundBucketNum', qs.stringify(params));
    },
    //品牌
    getGoodsBrandInfo(params) {
        return axios.post('/goods/mobileGoodsAlone/getFpGoodsBrandListAlone', qs.stringify(params));
    },
    //获取智能报货商品信息接口
    getIntelligentGoodsInfoAlone(params) {
        return axios.post('/goods/intelligentGoodsReportAlone/getIntelligentGoodsInfoAlone', qs.stringify(params));
    },
    batchAddBucketInfoAlone(params) {
        return axios.post('/goods/intelligentGoodsReportAlone/batchAddBucketInfoAlone', qs.stringify(params));
    },
    //爆款单品
    getPopularGoodsInfoAlone(params) {
        return axios.post('/goods/mobileGoodsAlone/getPopularGoodsInfoAlone', qs.stringify(params));
    },
    //手机前台获取新品发布的商品（独立版）
    getNewProductLaunchGoodsInfoList (params) {
        return axios.post('/goods/mobileGoodsAlone/getNewProductLaunchGoodsInfoList ', qs.stringify(params));
    },
    //订货端获取满赠/满减/满赠活动信息（独立版）
    getFullReductionDiscountGiveActivityAloneInfoList(params) {
        return axios.post('/goods/full/getFullReductionDiscountGiveActivityAloneInfoList', qs.stringify(params));
    },
    //常用清单接口
    getCommonAloneList(params) {
        return axios.post('/goods/mobileGoodsAlone/getCommonAloneList', qs.stringify(params));
    },
    //手机前台活动商品减少购物车（独立版）接口
    updateActivityGoodsBucket(params) {
        return axios.post('/goods/mobileActivityAlone/updateActivityGoodsBucket', qs.stringify(params));
    },
    getOnlineIntelligentGoodsInfoAlone(params) {
        return axios.post('/goods/intelligentGoodsReportAlone/getOnlineIntelligentGoodsInfoAlone', qs.stringify(params));
    },
    // 秒杀活动商品模块集合接口
    getActivityBaseGoodsList(params) {
        return axios.post('/goods/mobileActivityAlone/getActivityBaseGoodsList', qs.stringify(params));
    },
    
}

export default goodsAlone;


// WEBPACK FOOTER //
// ./src/request/api/goods/goods_alone.js